export const AboutObj ={
    id:'about',
    lightBg:true,
    lightText:false,
    lightTextDesc:false,
    topLine:'About me',
    headLine:"The possibilities are endless.",
    description:"Innovative and technically-astute software developer well-versed in analyzing user needs and developing software to precisely meet diverse needs.. Whether you need a visual update for your brand or website,Whether you're creating a subscription service, an on-demand marketplace or an e-commerce store.",
    // description:"I provide a variety of web related services as well as other creative web solutions. Whether you need a visual update for your brand or website,Whether you're creating a subscription service, an on-demand marketplace, an e-commerce store, or a portfolio showcase, Front's unmatched functionality help you create the best possible product for your users.",
    buttonLabel:"Get Started",
    imgStart:true,
    img:require('../../images/office.svg').default,
    alt:'office',
    dark:false,
    primary:false,
    darkText:true
}
